export default "__VITE_ASSET__B3mA8Cs6__"